import React from 'react'

import SummaryList from 'Components/organisms/summary-list'

const Summary = () => <SummaryList />

export default Summary
